export const BROKER_LEAD_CAPTURE_WEBHOOK =
  "https://hooks.zapier.com/hooks/catch/279836/au328n/";
export const INVESTOR_CONNECT_LEAD_CAPTURE_WEBHOOK =
  "https://hooks.zapier.com/hooks/catch/279836/wp3on9/";
